import { temAcesso } from '@/shared/auth/temAcesso'

const Projetos = () => import('./Projetos.vue')
const Projeto = () => import('./Projeto.vue')
const Etapa = () => import('../etapas/Etapa.vue')
const Rateio = () => import('../rateios/Rateio.vue')

export default {
    path: 'projetos',
    name: 'Sgtec_Uabs_Projetos',
    component: Projetos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('SGTEC-UABS-PRJ-00')) {
            next()
        }
    },
    children: [
        {
            path: ':projetoId',
            name: 'Sgtec_Uabs_Projetos_Detalhar',
            component: Projeto,
            beforeEnter: (to, from, next) => {
                if (temAcesso('SGTEC-UABS-PRJ-01')) {
                    next()
                }
            },
            children: [
                {
                    path: 'etapas/:etapaId',
                    name: 'Sgtec_Uabs_Projetos_Etapa_Detalhar',
                    component: Etapa,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('SGTEC-UABS-ETP-01')) {
                            next()
                        }
                    }
                },
                {
                    path: 'etapas/:etapaId/rateio',
                    name: 'Sgtec_Uabs_Etapas_Rateio',
                    component: Rateio,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('SGTEC-UABS-ETP-01')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
